import { makeStyles } from '@material-ui/core'

export default makeStyles((theme) => ({
  sdRoot: {
    alignItems: 'center',
    marginBottom: theme.spacing(6),
  },

  sdTitleContainer: {
    flexGrow: 0,
    flexShrink: 1,
  },

  sdTitle: {
    paddingRight: theme.spacing(1),
    color: ({ color }) => (color ? color : theme.palette.primary.main),
    textTransform: 'uppercase',
    fontFamily: 'Roboto Condensed',
    fontSize: theme.typography.caption.fontSize,
    fontWeight: theme.typography.fontWeightMedium,
    letterSpacing: theme.typography.letterSpacing,
  },

  sdDivider: {
    width: '100%',
  },
}))
